import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ExactTheme } from "./theme.ts";

export const NonConflictingThemeContext = createContext<ExactTheme | null>(
  null,
);

// This provider simply is a copy of ThemeProvider from emotion package
// But unlike emotion, this doesn't conflict with mui ThemeProvider
// we will be able to access our theme inside mui components, like DataGrid
export const NonConflictingThemeProvider = ({
  children,
  theme,
}: PropsWithChildren<{
  theme: ExactTheme;
}>) => {
  return (
    <NonConflictingThemeContext.Provider value={theme}>
      {children}
    </NonConflictingThemeContext.Provider>
  );
};
